<template>
  <div>
    <PageTable
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @radio-change="(e) => $emit('radio-change', e)"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        perfect
        size="mini"
        align="right"
        slot="pager"
        :layouts="['Total', 'Sizes', 'PrevPage', 'JumpNumber', 'NextPage']"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageTable>
  </div>
</template>

<script>
import PageTable from './table.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import { request } from '@/api/service'
export default {
  mixins: [BaseTable],
  components: { PageHeader, PageTable },
  data() {
    return { usePage: true }
  },
  methods: {
    getData(form) {
      this.loading = true
      const data = { ...form, ...this.page }
      request({
        url: '/factory/tc/fabric/purchase/optionalOrder',
        method: 'POST',
        data,
      })
        .then((res) => {
          this.loading = false
          this.$emit('radio-change', {})
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
